export const Section = ({ children, ...otherProps }) => {
  return <section {...otherProps}>{children}</section>;
};

export default Section;
